import * as React from "react"
import { ReadSpeakerLayout } from "./readspeaker.layout";
import { ReadspeakerProps } from "./readspeaker.state";

declare global {
  interface Window {
    rspkr: any
    // dataLayer: any
    ReadSpeaker: any
    // hotJar: any
  }
}

export class ReadSpeaker extends React.Component<ReadspeakerProps> {
  constructor(props:any) {
    super(props);
  }

  componentDidMount() {
    addRSPKRScript()
  }

  componentWillUnmount() {
    stopRSPKR()
  }

  render() {
    return <ReadSpeakerLayout.Button
      encodedUrl={this.props.encodedUrl}
      keyId={this.props.keyId}
      readElementId={this.props.readElementId}
    />
  }
}

export const encodeUrl = (UrltoBeEncoded: string): string => {
  let encodedUrl: string = encodeURI(UrltoBeEncoded)
  return encodedUrl
}

export const stopRSPKR = () => {
    if (window.rspkr && window.rspkr.ui && window.rspkr.ui !== undefined && window.rspkr !== undefined) {
        window.rspkr.ui.getActivePlayer()
            ? window.rspkr.ui.getActivePlayer().close()
            : null
    }
}

export const addRSPKRScript = () => {
  const existingScript = document.getElementById('rs_req_Init');
  
  if (!existingScript) {
    const script = document.createElement('script')
    script.id = "rs_req_Init"
    script.type = 'text/javascript'
    script.defer = true
    script.src = 'https://cdn1.readspeaker.com/script/11489/webReader/webReader.js?pids=wr&disable=dictionary,pagemask'
    script.onload = () => addRSPKREvents()
    document.body.appendChild(script)
  } else {
    addRSPKREvents();
  }
}

export const addRSPKREvents = () => {
  if(window?.ReadSpeaker?.q == null) return

  window.ReadSpeaker.q(function () {
      var listenStr = 'Luister', translateStr = 'Translate';
      if (window.rspkr.phrases) {
          var langKey = window.rspkr.mapLang('nl_nl'), listenKey = window.rspkr.mapPhrase('translation'), translateKey = window.rspkr.mapPhrase('listen');
          for (var pIndex = 0; pIndex < window.rspkr.phrases.length; pIndex++) {
              if (window.rspkr.phrases[pIndex].substr(0, 3) === langKey + listenKey) { window.rspkr.phrases[pIndex] = listenStr; }
              if (window.rspkr.phrases[pIndex].substr(0, 3) === langKey + translateKey) { window.rspkr.phrases[pIndex] = translateStr; }
          }
      } else {
          var updatedPhrases = { nl_nl: { listen: listenStr, translation: translateStr } };
          window.rspkr.cfg.extendPhrases(updatedPhrases);
      }

      if (window.rspkr.ui.getActivePlayer()) { window.rspkr.ui.getActivePlayer().close(); }
      window.rspkr.ui.addClickEvents();
  })
}
